import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Drawer,
  FormControl,
  FormControlLabel,
  InputAdornment,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Autocomplete } from "@material-ui/lab";
import SearchIcon from "@material-ui/icons/Search";
import CdmoWarning from "./CdmoWarning";
import axios from "axios";
import { appUrl } from "../../../../../../utils/config";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    minHeight: "90%",
  },
  textFieldWrapper: {
    marginBottom: theme.spacing(2),
  },
  buttonContainer: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "space-between",
    marginTop: "auto",
    marginBottom: theme.spacing(2),
    textTransform: "none",
  },
  content: {
    flexGrow: 1,
  },

  heading: {
    fontWeight: 600,
    marginBottom: "1em",
  },
  drawerPaper: {
    width: "30vw",
  },
  saveBtn: {
    backgroundColor: "#286acf",
    textTransform: "none",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#286acf",
    },
  },
}));

export default function AssociateCDMOs({
  user,
  setViewDetailsDrawer,
  handleRefresh,
  selectedRole,
}) {
  const classes = useStyles();
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [cdmoAPI, setCdmoAPI] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [fetchUserData, setFetchUserData] = useState([]);
  const [cdmoDetails, setCdmoDetails] = useState([]);
  const [discard, setDiscard] = useState(false); //toggle
  const [accessOption, setAccessOption] = useState(""); // Default to 'all' radio button
  const [associatedIds, setAssociatedIds] = useState(
  []
  );
  const [cdmoDrawer, setCdmoDrawer] = useState(false);
   // Handle radio button change
  const handleAccessChange = (event) => {
    const value = event.target.value;
    setAccessOption(value);
    if (value === "all") {
           // setAssociatedIds("all");
 const allCDMOIds = cdmoAPI.map((cdmo) => cdmo.organization_id);
setSelectedOptions(cdmoAPI);
  setAssociatedIds(allCDMOIds);
    }else if(value === "select"){
    setSelectedOptions([]);
    }
     else setAssociatedIds([]);
      };
  //fetch all cdmos
  const arraysAreEqual = (arr1, arr2) => {
  if (!Array.isArray(arr1) || !Array.isArray(arr2)) return false;

  const uniqueSorted1 = [...new Set(arr1)].sort((a, b) => a - b);
  const uniqueSorted2 = [...new Set(arr2)].sort((a, b) => a - b);

  if (uniqueSorted1.length !== uniqueSorted2.length) return false;

  return uniqueSorted1.every((val, index) => val === uniqueSorted2[index]);
};

//   useEffect(() => {
//     setLoading(true);
//     setAccessOption(fetchUserData?.data?.associatedCMOList.length === cdmoAPI.length ? "all" : "select");

//     // const url =
//     //   "https://api.mockfly.dev/mocks/6068d47d-50f1-44a0-bc11-f2a155dab121/fetchCdmoDetails";
//     const url = `${appUrl}/user/fetchCdmoDetails`;

//     axios
//       .get(url)
//       .then((res) => {
//         if (res.data.status) {
//          const cdmoList = res?.data?.data;
//          const associatedCMOList = fetchUserData?.data?.associatedCMOList;
//         setCdmoAPI(cdmoList); 
//           // const options = user.associated_cdmo_list
//           //   .map((selected) =>
//           //     res.data.data.find((item) => item.cdmo_id === selected.cdmo_id)
//           //   )
//           //   .filter(Boolean);
// if(fetchUserData?.data?.associatedCMOList){
//     const options = associatedCMOList
//   ?.map((associatedId) =>
//     cdmoAPI.find((cdmo) => cdmo.cdmo_id === associatedId)
//   )
//   .filter(Boolean);
// console.log("options",options)
//             // setCdmoDetails(res.data);
//           if (fetchUserData?.data?.associatedCMOList.length === cdmoAPI.length) {
//             setSelectedOptions([]);
//             setAssociatedIds("all");
//           } else {
//             setSelectedOptions(options);
//           }
//         }
//           // setCdmoAPI(res.data.data);
//         } else setCdmoAPI([]);
//       })
//       .catch((err) => {
//         setError(true);
//       })
//       .finally(() => setLoading(false),
//      );
//   }, [discard,fetchUserData]);
// First useEffect: Fetch CDMO data
// useEffect(() => {
//   setLoading(true);
//   const url = `${appUrl}/user/fetchCdmoDetails`;

//   axios
//     .get(url)
//     .then((res) => {
//       if (res.data.status) {
//          setCdmoAPI(res.data.data); // ✅ Only set data here
//       } else {
//         setCdmoAPI([]);
//       }
//     })
//     .catch((err) => {
//       setError(true);
//     })
//     .finally(() => setLoading(false));
// }, [discard]);

useEffect(() => {
  setLoading(true);

  const { appName, network, collabType, roleName, ecosystemId, organizationName } = localStorage;

  const url = `${appUrl}/${appName}/${network}/${collabType}/${roleName}/fetchCMOMembers`;

  const payload = {
    collabType,
    roleName,
    organizationName,
    ecosystemId,
  };

  axios
    .post(url, payload)
    .then((res) => {
      if (res.data.status) {
        setCdmoAPI(res.data.CMOMembersWithId);
        setError(null);
      } else {
        setCdmoAPI([]);
      }
    })
    .catch((err) => {
      setError(err.message);
      console.error(err.message);
    })
    .finally(() => {
      setLoading(false);
    });
}, [discard]);

// Second useEffect: Use cdmoAPI + fetchUserData to set options
useEffect(() => {
  if (
    Array.isArray(cdmoAPI) &&
    cdmoAPI.length &&
    Array.isArray(fetchUserData?.data?.associatedCMOList)
  ) {
    const associatedCMOList = fetchUserData.data.associatedCMOList;
    const options = associatedCMOList
      .map((id) => cdmoAPI.find((cdmo) => cdmo.organization_id === id))
      .filter(Boolean);
     if (associatedCMOList.length === cdmoAPI.length) {
      // setSelectedOptions([]);
      setSelectedOptions(cdmoAPI);
      // setAssociatedIds("all");
  const allCDMOIds = cdmoAPI.map((cdmo) => cdmo.organization_id);
    // console.log("allCDMONames",allCDMONames)
  setAssociatedIds(allCDMOIds);
      setAccessOption("all");
    } else {
      setSelectedOptions(options);
      setAssociatedIds(associatedCMOList); // or whatever logic you need
      setAccessOption("select");
    }
  }
}, [cdmoAPI, fetchUserData]);

const associatedCMOList = fetchUserData?.data?.associatedCMOList ?? [];

const isSaveDisabled =
  associatedIds === "" ||
  arraysAreEqual(associatedIds, associatedCMOList);

    useEffect(() => {
      setLoading(true);
      // setAccessOption(user?.associatedCDMOOrgIDs === "all" ? "all" : "select");
  
      // const url =
      //   "https://api.mockfly.dev/mocks/6068d47d-50f1-44a0-bc11-f2a155dab121/fetchCdmoDetails";
    const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchUserAssociations/${user?.saas_user_id}`;
  
      axios
        .get(url)
        .then((res) => {
        if(res.data.status){
  setFetchUserData(res.data)
  // setFetchUserData(userAssociationAPI);
        }
        })
        .catch((err) => {
          setError(true);
        })
        .finally(() => setLoading(false));
    }, []);

  const handleSave = () => {
    setCdmoDrawer(true);
  };
  const displayLoading = (
    <div style={{ textAlign: "center", marginTop: "1.5em" }}>
      <CircularProgress color="primary" thickness={7} />
    </div>
  );
  const displayError = (
    <Box
      style={{
        border: "2px solid rgb(255,0,0)",
        backgroundColor: "rgb(255,240,240)",

        textAlign: "center",
        padding: "0.8rem",
        fontSize: "0.875rem",
        marginTop: "1.5em",
      }}
    >
      {" "}
      <Typography variant="body2">
        Something went wrong. Please try again later.
      </Typography>
    </Box>
  );

  const displayNoRecordsFound = (
    <Box
      style={{
        display: "flex",
        justifyContent: "center", // Horizontally center the CircularProgress
        alignItems: "center", // Vertically center the CircularProgress
        height: "50px", // Optional: Set a height to vertically center the loader
        border: "2px solid #000",
        // backgroundColor: "#FFF0F0",
        width: "100%",
        marginTop: "1.5em",
      }}
    >
      <Typography style={{ textAlign: "center" }}>No records found</Typography>
    </Box>
  );
  if (loading) return displayLoading;
  if (error) return displayError;
  if (cdmoAPI?.length === 0) return displayNoRecordsFound;
  return (
    <Box
      style={{ minHeight: "100%", display: "flex", flexDirection: "column" }}
    >
      <Typography className={classes.heading}>Associate CMOs</Typography>
      <FormControl style={{ width: "100%" }}>
        <RadioGroup row value={accessOption} onChange={handleAccessChange}>
          <FormControlLabel
            value="all"
            control={<Radio color="primary" />}
            label={
              <span style={{ fontSize: "14px" }}>
                {`Access all CMOs (${cdmoAPI.length} CMOs)`}
              </span>
            }
          />
          <FormControlLabel
            value="select"
            control={<Radio color="primary" />}
            label={
              <span style={{ fontSize: "14px" }}>Access select CMOs</span>
            }
          />
        </RadioGroup>
      </FormControl>
      <FormControl style={{ width: "100%", height: "100%" }}>
        <Autocomplete
          multiple
          size="small"
          value={selectedOptions}
          options={cdmoAPI}
          getOptionLabel={(option) => option.organization_name}
          onChange={(event, value) => {
            setSelectedOptions(value);
            setAssociatedIds(value.map((option) => option.organization_id));
          }}
          disabled={accessOption === "all"}
          disableCloseOnSelect
          renderInput={(params) => (
            <TextField
              size="small"
              {...params}
              variant="outlined"
              placeholder="Start typing to search"
              InputProps={{
                ...params.InputProps,
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon fontSize="small" />
                  </InputAdornment>
                ),
              }}
            />
          )}
          renderOption={(option, { selected }) => (
            <React.Fragment>
              <Checkbox
                checked={selected}
                style={{ marginRight: 8 }}
                color="primary"
              />
              {option.organization_name}
            </React.Fragment>
          )}
        />
      </FormControl>
      <FormControl
        style={{ marginTop: "1em", marginBottom: "1em", width: "100%" }}
      >
        <Typography variant="body1">Your selections</Typography>
        <TextField
          disabled
          size="small"
          minRows={4}
          fullWidth
          value={
            selectedOptions.map((option) => option.organization_name).join(", ") || ""
          } // Display selected names
          variant="outlined"
          InputProps={{
            readOnly: true,
          }}
          multiline
          style={{ width: "100%" }}
        />
      </FormControl>

      <Box className={classes.buttonContainer}>
        <Button
          size="small"
          variant="contained"
          onClick={() => {
            setDiscard((prev) => !prev);
          }}
          style={{ textTransform: "none" }}
        >
          Discard changes
        </Button>
        <Button
          size="small"
          variant="contained"
          className={classes.saveBtn}
          onClick={handleSave}
          disabled={isSaveDisabled}
        >
          Save changes
        </Button>
      </Box>
      <Drawer
        anchor="right"
        open={cdmoDrawer}
        onClose={() => setCdmoDrawer(false)}
        classes={{ paper: classes.drawerPaper }}
        BackdropProps={{ style: { backgroundColor: "transparent" } }}
      >
        <CdmoWarning
          setCdmoDrawer={setCdmoDrawer}
          associatedIds={associatedIds}
          user={user}
          setViewDetailsDrawer={setViewDetailsDrawer}
          handleRefresh={handleRefresh}
          selectedRole={selectedRole}
        />
      </Drawer>
    </Box>
  );
}
